'use client';

import { Button, Transition, Typography } from 'components';
import { GlossaryCreateClipArt } from 'lib/svgs/ClipArts';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useGlossaryContext } from './_context/GlossaryContext';

export default function GlossaryPage() {
  const t = useTranslations();
  const { hasGlossary, isChecking } = useGlossaryContext();

  if (hasGlossary && !isChecking) return null;

  return (
    <div className="flex h-full flex-1 flex-col items-center justify-center">
      <Transition className="mb-14 flex h-24 justify-center">
        <GlossaryCreateClipArt className="h-[170px] w-[170px]" />
      </Transition>
      <Transition delay={0.6}>
        <div className="mb-6 mt-12">
          <Typography variant="medium7xl" className="!mt-0 flex justify-center text-tertiary-100">
            {t('glossary.new.home.title')}
          </Typography>
        </div>
        <div className="mb-12 max-w-3xl">
          <Typography variant="light3" className="m-0 !leading-7 text-tertiary-200">
            <div className="text-center">{t('glossary.new.home.paragraph')}</div>
          </Typography>
        </div>
      </Transition>
      <Transition delay={1.2} className="flex ">
        <Link href="/glossary/list">
          <Button label={t('glossary.new.continue')} />
        </Link>
      </Transition>
    </div>
  );
}
